import { useEffect, useState } from 'react';

export const MENU_ANIMATION_DURATION = 220;

/**
 * Keeps transient editor UI mounted long enough to finish its exit animation.
 * Closed content is removed afterwards so large node-specific menus stay cheap.
 */
const useAnimatedPresence = (visible, duration = MENU_ANIMATION_DURATION) => {
  const [rendered, setRendered] = useState(Boolean(visible));

  useEffect(() => {
    if (visible) {
      setRendered(true);
      return undefined;
    }

    const timer = setTimeout(() => setRendered(false), duration);
    return () => clearTimeout(timer);
  }, [duration, visible]);

  return rendered;
};

export default useAnimatedPresence;
